// extracted by mini-css-extract-plugin
export default {"ctaWrapper":"Aba-z","subtitle":"Bba-z","wrapper":"Cba-z","leftArrow":"Dba-z","rightArrow":"Eba-z"};